import { get } from '.';
import qs from 'qs';

export const getKinds = ({ filters }) => get(`/kinds?${qs.stringify(filters)}`);
